export const companyInfo = {
  name: "EduITalent",
  tagline: "Empowering Growth Through Expert Services",
  description:
    "We provide comprehensive professional services to help businesses and individuals achieve their goals through innovative solutions and expert guidance.",

  email: "info@eduitalent.com",

  phone: "+91-8376913569 / 7838305432",
  phone2: "+971-505382297",

  address: "2106A, 21st Floor, The iConic Corenthum Tower, Sector 62 Noida 201309",
  address2:
    "Al Basma Business Centre, Kazim Building - Office No.101 - Garhoud - Dubai",

  social: {
    linkedin: "",
    twitter: "",
    facebook: "",
    instagram: "",
  },
};

export const Services = [
  {
    id: 1,
    title: "Corporate Training",
    description:
      "Customized training programs designed to enhance your team's skills and boost productivity with hands-on learning experiences.",
    icon: "GraduationCap",
  },
  {
    id: 2,
    title: "Business Consulting",
    description:
      "Strategic guidance to help your organization overcome challenges and achieve sustainable growth in competitive markets.",
    icon: "Briefcase",
  },
  {
    id: 3,
    title: "Digital Transformation",
    description:
      "Modernize your business operations with cutting-edge technology solutions and digital strategies that drive results.",
    icon: "Laptop",
  },
  {
    id: 4,
    title: "Leadership Development",
    description:
      "Comprehensive programs that cultivate strong leaders who inspire teams and drive organizational success.",
    icon: "Users",
  },
  {
    id: 5,
    title: "Career Coaching",
    description:
      "Personalized coaching sessions to help professionals navigate their career path and achieve their professional goals.",
    icon: "Target",
  },
  {
    id: 6,
    title: "Talent Acquisition",
    description:
      "Strategic recruitment solutions to help you find and retain top talent that aligns with your company culture.",
    icon: "UserCheck",
  },
];
